import Centrifuge from 'centrifuge';
import ddt from '@wix/da-ddt';
var initialRetry = 2;
var maxRetry = 900;
var maxMessageIdsToKeep = 512; // Limit of how many message we remember IDs from in order to dedupe without unbounded memory growth
var lastMsgIds = [];
// Create de-duping data structure
var isDupe = function (msgId) {
    // This is fast enough over small history despite being O(N) in general
    // @ts-ignore
    return lastMsgIds.indexOf(msgId) > -1;
};
var recordMsgId = function (msgId) {
    if (lastMsgIds.length === maxMessageIdsToKeep) {
        lastMsgIds.shift();
    }
    // @ts-ignore
    lastMsgIds.push(msgId);
};
function isValid(message) {
    // Check if it's already expired
    var now = new Date().getTime();
    if (message.data.ts &&
        message.data.ttl &&
        (message.data.ts + message.data.ttl) * 1000 < now) {
        return false;
    }
    // De-dupe
    if (message.data.mid) {
        if (isDupe(message.data.mid)) {
            return false;
        }
        else {
            recordMsgId(message.data.mid);
        }
    }
    return true;
}
var getClient = function (endpoint, user, timestamp, token, subscriptions, onReceipt) {
    try {
        var client_1 = new Centrifuge({
            url: endpoint,
            timestamp: timestamp,
            user: user,
            token: token,
            retry: initialRetry * 1000,
            maxRetry: maxRetry * 1000,
            debug: true,
        });
        client_1.on('error', function (error) {
            ddt.error('hub', 'error:', error);
        });
        client_1.on('disconnect', function (ev) {
            ddt.error('hub', 'disconnect:', ev);
        });
        client_1.on('connect', function (ctx) {
            client_1.startBatching();
            var subs = [];
            var _loop_1 = function (channel) {
                subs[channel] = client_1.subscribe(channel, function (message) {
                    var valid = isValid(message);
                    ddt.log('hub', channel, message, 'valid:', valid);
                    valid && onReceipt(message);
                });
                subs[channel].on('subscribe', function (context) {
                    var action = context.isResubscribe ? 'resubscribed' : 'subscribed';
                    ddt.log('hub', "Successfully " + action + " to channel " + context.channel);
                });
            };
            for (var _i = 0, subscriptions_1 = subscriptions; _i < subscriptions_1.length; _i++) {
                var channel = subscriptions_1[_i];
                _loop_1(channel);
            }
            // Send all subscription messages
            client_1.stopBatching(true);
        });
        ddt.log('hub', 'run connect');
        client_1.connect();
        return client_1;
    }
    catch (e) {
        ddt.error('hub', 'Failed to connect to hub', e);
    }
};
export function setupHub(hubConfig, onReceipt) {
    ddt.log('hub', 'setupHub:', hubConfig);
    getClient(hubConfig.endpoint, hubConfig.user, hubConfig.ts, hubConfig.auth, hubConfig.subs, onReceipt);
}
export function breakdownHub() {
    ddt.log('hub', 'breakdownHub:');
}
//# sourceMappingURL=hub.js.map